import { ID_QUERY, CommonRes } from './common';

export const CTA_ITEM_QUERY = `
  title
  ${ID_QUERY}
  subTitle
  buttonText
  url
  ctaIdentifier
  infoMessage
  infoMessageElementId
  image{
    url
  }
  imageDescription
`;

export interface CtaResItem extends CommonRes {
  title: string;
  subTitle: string;
  buttonText: string;
  url: string;
  ctaIdentifier: string;
  infoMessage: string;
  infoMessageElementId: string;
  image: {
    url: string;
  };
  imageDescription: string;
}

export class Cta {
  id: string;
  title: string;
  subTitle: string;
  buttonText: string;
  url: string;
  ctaIdentifier: string;
  image: string;
  imageDescription: string;

  constructor(item: CtaResItem) {
    this.id = item.sys.id;
    this.title = item.title;
    this.subTitle = item.subTitle;
    this.buttonText = item.buttonText;
    this.url = item.url;
    this.ctaIdentifier = item.ctaIdentifier;
    this.image = item.image?.url || '';
    this.imageDescription = item.imageDescription;
  }
  static getQuery = () => {
    return `
      query {
        tagCollection(
          limit: 1000,
        ){
          items{
            title
            ${ID_QUERY}
            subTitle
            buttonText
            url
            ctaIdentifier
            infoMessage
            infoMessageElementId
            image{
              url
            }
            imageDescription
          }
        }
      }
    `;
  };
}
